<template>
  <div class="common-bg">
    <div class="tool-drawer-header">
      <a @click="clickBack">
        <a-icon type="left" />
      </a>
      <div class="title">{{$t('edit.injectInfo.addText')}}</div>
    </div>
    <div class="tool-drawer-content">
      <!-- 標題 -->
      <div class="tit-box" style="padding-top: 0">
        <div class="tit-desc">
          <span>{{$t('edit.title')}}</span>
        </div>
        <a-input :placeholder="$t('edit.hpInfo.inputTitle')" v-model="pasterObj.title" />
      </div>
      <div style="margin: 0 24px">
        <span style="line-height: 4">{{$t('edit.textInfo')}}</span>
        <a-textarea
                :placeholder="$t('common.inputContent')"
                :rows="10"
                v-model="pasterObj.content"
        />
      </div>
    </div>

    <div class="tool-drawer-btns">
      <DoubleBtn
              @onClickSave="handleClickSave"
              @onClickCancel="clickDelete"
      ></DoubleBtn>
    </div>

  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import DoubleBtn from "../DoubbleBtn";

export default {
  components: { DoubleBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      pasterObj: {
        type: "word",
        paster_id: "paster" + uuidv4(),
        ath: "",
        atv: "",
        content: "",
        title: "",
        note: this.$t('edit.injectInfo.pasterText'),
      },
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.pasterObj = value;
        }
      },
      immediate: true,
      deep: true,
    },
    newPasterObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.pasterObj.ath = vh.hlookat;
          this.pasterObj.atv = vh.vlookat;
        }
        this.$emit("change", this.pasterObj, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    newPasterObj() {
      return this.$deepClone(this.pasterObj);
    },
  },
  mounted() {
    this.$bus.$on("updatePaster", (e) => {
      if (e.paster_id == this.pasterObj.paster_id) {
        this.pasterObj.ath = e.ath;
        this.pasterObj.atv = e.atv;
      }
    });
  },
  methods: {
    clickBack() {
      this.$emit("clickBack", this.pasterObj);
    },
    clickDelete() {
      this.$emit("clickDelete", this.pasterObj);
    },
    handleClickSave() {
      this.$emit("saveDataToStore", {
        key: this.pasterObj.paster_id,
        data: this.pasterObj,
      });
    },
  },
};
</script>
